import { render, staticRenderFns } from "./RoadMapSection.vue?vue&type=template&id=bb4e63ec"
import script from "./RoadMapSection.vue?vue&type=script&lang=ts"
export * from "./RoadMapSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports